(function () {
  var bar = document.querySelector('[data-lushe-sticky-atc]');
  if (!bar) return;

  var sid = bar.getAttribute('data-section-id');
  var mainBtn = document.getElementById('ProductSubmitButton-' + sid);
  if (!mainBtn) return;

  var btn = bar.querySelector('[data-lushe-sticky-btn]');
  var priceEl = bar.querySelector('[data-lushe-sticky-price]');
  var priceWrap = document.getElementById('price-' + sid);
  var multi = bar.getAttribute('data-multi') === 'true';
  var picked = false; // has the shopper actively chosen a size/colour yet?
  var mainVisible = false;
  var mq = window.matchMedia('(max-width: 749px)');

  function syncPrice() {
    var el = priceWrap && priceWrap.querySelector('.price-item--last');
    if (el && priceEl) priceEl.textContent = el.textContent.trim();
  }

  // With several sizes/colours the first one is preselected, so adding blindly
  // could put the wrong size in the cart. Until the shopper picks something the
  // bar scrolls them to the options instead; after that it adds to cart.
  function syncLabel() {
    var soldOut = mainBtn.disabled && (!multi || picked);
    if (soldOut) {
      btn.textContent = 'Sold out';
      btn.disabled = true;
    } else {
      btn.disabled = false;
      btn.textContent = multi && !picked ? 'Choose options' : 'Add to cart';
    }
  }

  function render() {
    var show = mq.matches && !mainVisible;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    btn.tabIndex = show ? 0 : -1;
    document.body.classList.toggle('lushe-sticky-atc-on', show);
  }

  // Visible whenever the real button is NOT on screen - above the fold on
  // load, and again once the shopper has scrolled past it.
  new IntersectionObserver(function (entries) {
    mainVisible = entries[0].isIntersecting;
    render();
  }).observe(mainBtn);

  if (mq.addEventListener) mq.addEventListener('change', render);

  btn.addEventListener('click', function () {
    if (multi && !picked) {
      var target = document.querySelector('variant-selects, variant-radios') || mainBtn;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      mainBtn.click();
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
      picked = true;
      syncLabel();
      setTimeout(function () { syncPrice(); syncLabel(); }, 700);
    }
  });

  if (priceWrap) {
    new MutationObserver(syncPrice).observe(priceWrap, { childList: true, subtree: true, characterData: true });
  }
  new MutationObserver(syncLabel).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });

  syncPrice();
  syncLabel();
  render();
})();
